module.exports = __webpack_public_path__ + "media/images/payment/ppcom-white-17f94caa49ea28e8272195b52c0cf1ea.svg";